import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Link, useLocation, useParams } from "react-router-dom";
import { LoadingPanel } from "../../components/layout/Loading";
import moment from "moment";
import { checkAcessRights, formatIndianNumber } from "../../_helper/helper";
import { getFITBookingByID } from "./services/FITBooking.services";
import { PDF_DOWNLOAD_ACCESS, PRINT_ACCESS } from "../../_contstants/common";
import { Button } from "@progress/kendo-react-buttons";
import { ErrorToast } from "../../components/toast/Toasts";
import { API_URL } from "../../app/config";
import defaultitineraryimage from "../../assets/Images/default-itinerary-image.jpg";
import NoDataFoundPage from "../../components/common/NoDataFoundPage";

const FITBookingPrint = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const params = useParams();
  const PackageBooking_GUID = params?.PackageBooking_GUID;

  const location = useLocation();

  const withoutBifurcation = location.search?.split("?")?.[1] === "wb";

  const loading = useAppSelector((state) => state.FITBooking.loading);
  const FITBookingDetail = useAppSelector(
    (state) => state.FITBooking.FITBookingDetail,
  );

  const isPrintAccess = checkAcessRights("/fitbooking", PRINT_ACCESS);
  const isPDFDownloadAccess = checkAcessRights(
    "/fitbooking",
    PDF_DOWNLOAD_ACCESS,
  );
  const [downloadLoading, setDownloadLoading] = useState(false);

  const CompanyDetail = FITBookingDetail?.CompanyDetails;
  const TotalAccommodationRate = FITBookingDetail?.TotalAccomodation || 0;
  const TotalTransportation = FITBookingDetail?.TotalTransport || 0;
  const TotalMiscellaneous = FITBookingDetail?.TotalMiscellinious || 0;
  const TotalSightSeen = FITBookingDetail?.TotalSightSeen || 0;

  const convertedTotalAccommodationRate =
    (+(FITBookingDetail?.AccommodationMarkup || 0) + +TotalAccommodationRate) *
      (FITBookingDetail?.AccommodationConversionRate || 0) || 0;
  const convertedTotalTransportation =
    (+(FITBookingDetail?.TransportMarkup || 0) + +TotalTransportation) *
      (FITBookingDetail?.TransportaionConversionRate || 0) || 0;
  const convertedTotalMiscellaneous =
    (+(FITBookingDetail?.MiscellaneousMarkup || 0) + +TotalMiscellaneous) *
      (FITBookingDetail?.MiscellaneousConversionRate || 0) || 0;
  const convertedTotalSightSeen =
    (+(FITBookingDetail?.SightSeenMarkup || 0) + +TotalSightSeen) *
      (FITBookingDetail?.SightSeenConversionRate || 0) || 0;

  useEffect(() => {
    if (PackageBooking_GUID) {
      dispatch(getFITBookingByID({ PackageBooking_GUID: PackageBooking_GUID }));
    }
  }, [PackageBooking_GUID]);

  const calculateSubtotal = (): number => {
    return (
      convertedTotalAccommodationRate +
      convertedTotalTransportation +
      convertedTotalMiscellaneous +
      convertedTotalSightSeen
    );
  };

  const calculateAfterDiscount = (): number => {
    return calculateSubtotal() - (FITBookingDetail.DiscountAmt || 0);
  };

  const handleHotelVoucherView = (ID: any) => {
    window.open(`/hotelvoucherview/${ID}/${PackageBooking_GUID}`);
  };

  const handleDownloadPrint = async (ID: any) => {
    const payload = {
      ID: ID ? +ID : null,
      Is_Bifurcation: withoutBifurcation,
    };
    setDownloadLoading(true);
    try {
      //TODO: need to add condition when Without Bifurcation API DONE.
      const response = await fetch(
        `${API_URL}/PackageBooking/PackageBookingDownload`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
          body: JSON.stringify(payload),
        },
      );
      if (!response.ok) {
        ErrorToast("Failed to generate PDF! - Please try after some time");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `${FITBookingDetail?.FirstName} ${
        FITBookingDetail?.LastName
      } - FIT Booking ${FITBookingDetail?.TourBookingNo || ""}.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download! - Please try again later");
    } finally {
      setDownloadLoading(false);
    }
  };
  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      {downloadLoading && <LoadingPanel gridRef={gridRef} />}
      {FITBookingDetail?.ID ? (
        <>
          <div className="no-visible-print-btn text-center mt-3">
            {isPrintAccess && (
              <Button
                type="button"
                style={{
                  marginRight: 10,
                  width: 100,
                }}
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

            {isPDFDownloadAccess && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => handleDownloadPrint(FITBookingDetail?.ID)}
                style={{ marginRight: 5, width: 100 }}
              >
                Download
              </Button>
            )}
          </div>
          <div className="quotation-container">
            <div className="row">
              <div className="col-2 d-flex align-items-center">
                <img src={CompanyDetail?.CompanyLogo} alt="" width="100%" />
              </div>
              <div className="col-7" style={{ borderLeft: "1px solid black" }}>
                <h5 className="fw-600">{CompanyDetail?.CompanyName}</h5>
                <div className="d-flex" style={{ gap: 100 }}>
                  <span>
                    <span className="fw-600">GST : </span>{" "}
                    {CompanyDetail?.GSTNo}
                  </span>
                </div>
                <div className="d-flex" style={{ gap: 100 }}>
                  <span>
                    <span className="fw-600">PAN : </span>{" "}
                    {CompanyDetail?.PANNo}
                  </span>
                </div>
                <div className="d-flex" style={{ gap: 100 }}>
                  <span>
                    <span className="fw-600">Mobile : </span>{" "}
                    {CompanyDetail?.MobileNo}
                  </span>
                </div>
                <div>
                  <span className="fw-600">Email : </span>{" "}
                  {CompanyDetail?.EmailID}
                </div>
              </div>
              <div
                className="col-3"
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {CompanyDetail?.Address} <br />
                {CompanyDetail?.CityName} - {CompanyDetail?.Pincode} <br />
                State: {CompanyDetail?.StateName} <br />
                Country: {CompanyDetail?.CountryName}
              </div>
            </div>
            <div className="section-title main-title">Tour Details</div>
            <div className="details-section">
              <table className="details-table">
                <tbody>
                  <tr>
                    <td>
                      <span className="info-label">Name:</span>{" "}
                      <span className="highlight">
                        {FITBookingDetail?.FirstName}{" "}
                        {FITBookingDetail?.LastName}
                      </span>
                    </td>
                    <td className="w-50">
                      <span className="info-label">Date:</span>{" "}
                      {moment(FITBookingDetail?.CreatedOn).format("DD/MM/YYYY")}
                    </td>
                  </tr>
                  <tr>
                    <td className="w-50">
                      <span className="info-label">Mobile No.:</span>{" "}
                      {FITBookingDetail?.MobileNo}
                    </td>
                    <td className="w-50">
                      <span className="info-label">Email ID:</span>{" "}
                      {FITBookingDetail?.EmailID}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="info-label">Pick Up Place:</span>{" "}
                      {FITBookingDetail?.PickUpPlace}
                    </td>
                    <td>
                      <span className="info-label">Drop Place:</span>{" "}
                      {FITBookingDetail?.DropPlace}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="info-label">Pick Up Date:</span>{" "}
                      {FITBookingDetail?.PickUpDate
                        ? moment(FITBookingDetail?.PickUpDate).format(
                            "DD/MM/YYYY",
                          )
                        : ""}
                    </td>

                    <td>
                      <span className="info-label">Drop Date:</span>{" "}
                      {FITBookingDetail?.DropDate
                        ? moment(FITBookingDetail?.DropDate).format(
                            "DD/MM/YYYY",
                          )
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="info-label">Total Adult:</span>{" "}
                      {FITBookingDetail?.TotalAdults}
                    </td>

                    <td>
                      <span className="info-label ">Total Room:</span>{" "}
                      {FITBookingDetail?.TotalNoOfRooms}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="info-label ">Total CNB:</span>{" "}
                      {FITBookingDetail?.TotalCNB}
                    </td>
                    <td>
                      <span className="info-label">Total CWB:</span>{" "}
                      {FITBookingDetail?.TotalCWB}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="section-title">Accommodation Details</div>
            <div className="section">
              {!withoutBifurcation && (
                <div className="info d-flex justify-content-between">
                  <div>
                    <span className="info-label">
                      Total Rate{" "}
                      {FITBookingDetail?.AccommodationCurrencyName &&
                      FITBookingDetail?.AccommodationCurrencyName !== "INR"
                        ? `(${FITBookingDetail?.AccommodationCurrencyName}) `
                        : ""}
                      :
                    </span>{" "}
                    <span className="highlight">
                      {formatIndianNumber(
                        +(FITBookingDetail?.TotalAccomodation || 0) +
                          +(FITBookingDetail?.AccommodationMarkup || 0),
                      )}
                    </span>
                  </div>
                  <div>
                    <span className="info-label">Conversion Rate :</span>{" "}
                    <span className="highlight">
                      {formatIndianNumber(
                        FITBookingDetail?.AccommodationConversionRate || 0,
                      )}
                    </span>
                  </div>
                </div>
              )}
              {FITBookingDetail?.Accommodations?.length > 0 && (
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Place</th>
                      <th>Hotel</th>
                      <th>Check-In Date</th>
                      <th>Check-Out Date</th>
                      <th>Room Type</th>
                      <th>Meal Type</th>
                      <th>Total Room</th>
                    </tr>
                  </thead>
                  <tbody>
                    {FITBookingDetail?.Accommodations.map(
                      (accommodation, index) => (
                        <tr key={index}>
                          <td>{accommodation?.Place}</td>
                          <td>
                            <p
                              className="mb-0 cursor-pointer fw-600"
                              style={{ color: "#0073e6" }}
                              onClick={() =>
                                handleHotelVoucherView(
                                  accommodation?.AccomodationID,
                                )
                              }
                            >
                              {accommodation?.HotelName}
                            </p>
                          </td>
                          <td>
                            {accommodation?.CheckInDate
                              ? moment(accommodation?.CheckInDate).format(
                                  "DD/MM/YYYY",
                                )
                              : ""}
                          </td>
                          <td>
                            {accommodation?.CheckOutDate
                              ? moment(accommodation?.CheckOutDate).format(
                                  "DD/MM/YYYY",
                                )
                              : ""}
                          </td>
                          <td>
                            {!isNaN(Number(accommodation?.Hotel))
                              ? accommodation?.RoomType
                              : accommodation?.RoomCategoryName}
                          </td>
                          <td>{accommodation?.MealType}</td>
                          <td>{accommodation?.TotalRoom}</td>
                        </tr>
                      ),
                    )}
                  </tbody>
                </table>
              )}
            </div>

            {/* Transport Details Section */}
            {FITBookingDetail?.Transportations?.length > 0 && (
              <>
                <div className="section-title">Transport Details</div>
                <div className="section">
                  {!withoutBifurcation && (
                    <div className="info d-flex justify-content-between">
                      <div className="d-flex gap-3">
                        <div>
                          <span className="info-label">
                            Driver Allowance{" "}
                            {FITBookingDetail?.TransportaionCurrencyName &&
                            FITBookingDetail?.TransportaionCurrencyName !==
                              "INR"
                              ? `(${FITBookingDetail?.TransportaionCurrencyName}) `
                              : ""}
                            :
                          </span>{" "}
                          <span className="highlight">
                            {formatIndianNumber(
                              FITBookingDetail?.DriverAllowance || 0,
                            )}
                          </span>
                        </div>
                        <span className="fw-bold" style={{ color: "#0073e6" }}>
                          |
                        </span>
                        <div>
                          <span className="info-label">
                            Toll Tax{" "}
                            {FITBookingDetail?.TransportaionCurrencyName &&
                            FITBookingDetail?.TransportaionCurrencyName !==
                              "INR"
                              ? `(${FITBookingDetail?.TransportaionCurrencyName}) `
                              : ""}
                            :
                          </span>{" "}
                          <span className="highlight">
                            {formatIndianNumber(
                              FITBookingDetail?.TotalTax || 0,
                            )}
                          </span>
                        </div>
                      </div>
                      <div>
                        <span className="info-label">Conversion Rate :</span>{" "}
                        <span className="highlight">
                          {formatIndianNumber(
                            FITBookingDetail?.TransportaionConversionRate || 0,
                          )}
                        </span>
                      </div>
                    </div>
                  )}

                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Vehicle Type</th>
                        <th>Place</th>
                        <th>From Date</th>
                        <th>To Date</th>
                        {/* <th>Rate</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {FITBookingDetail?.Transportations.map(
                        (transport, index) => (
                          <tr key={index}>
                            <td>{transport.VehicleType}</td>
                            <td>{transport.Place}</td>
                            <td>
                              {transport.FromDate
                                ? moment(transport.FromDate).format(
                                    "DD/MM/YYYY",
                                  )
                                : ""}
                            </td>
                            <td>
                              {transport.ToDate
                                ? moment(transport.ToDate).format("DD/MM/YYYY")
                                : ""}
                            </td>
                            {/* <td>{formatIndianNumber(transport.Rate || 0)}</td> */}
                          </tr>
                        ),
                      )}
                    </tbody>
                  </table>

                  {!withoutBifurcation && (
                    <div className="info text-end">
                      <span className="info-label">Total:</span>{" "}
                      <span className="highlight">
                        {formatIndianNumber(
                          +(FITBookingDetail?.TotalTransport || 0) +
                            +(FITBookingDetail?.TransportMarkup || 0),
                        )}
                      </span>
                    </div>
                  )}
                </div>
              </>
            )}

            {/* Miscellaneous Details Section */}
            {FITBookingDetail?.Miscellaneous?.length > 0 && (
              <>
                <div className="section-title">Miscellaneous Details</div>
                <div className="section">
                  {!withoutBifurcation && (
                    <div className="info d-flex justify-content-between">
                      <div>
                        <span className="info-label">
                          Total Rate{" "}
                          {FITBookingDetail?.MiscellaneousCurrencyName &&
                          FITBookingDetail?.MiscellaneousCurrencyName !== "INR"
                            ? `(${FITBookingDetail?.MiscellaneousCurrencyName}) `
                            : ""}
                          :
                        </span>{" "}
                        <span className="highlight">
                          {formatIndianNumber(
                            +(FITBookingDetail?.TotalMiscellinious || 0) +
                              +(FITBookingDetail?.MiscellaneousMarkup || 0),
                          )}
                        </span>
                      </div>
                      <div>
                        <span className="info-label">Conversion Rate :</span>{" "}
                        <span className="highlight">
                          {formatIndianNumber(
                            FITBookingDetail?.MiscellaneousConversionRate || 0,
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Title</th>
                        {/* <th>Total Amount</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {FITBookingDetail?.Miscellaneous.map((misc, index) => (
                        <tr key={index}>
                          <td>{misc.Title}</td>
                          {/* <td>{formatIndianNumber(misc.TotalAmount || 0)}</td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}

            {/* Sightseen Details Section */}
            {FITBookingDetail?.SightSeen?.length > 0 && (
              <>
                <div className="section-title">SightSeen Details</div>
                <div className="section">
                  {!withoutBifurcation && (
                    <div className="info d-flex justify-content-between">
                      <div>
                        <span className="info-label">
                          Total Rate{" "}
                          {FITBookingDetail?.SightSeenCurrencyName &&
                          FITBookingDetail?.SightSeenCurrencyName !== "INR"
                            ? `(${FITBookingDetail?.SightSeenCurrencyName}) `
                            : ""}
                          :
                        </span>{" "}
                        <span className="highlight">
                          {formatIndianNumber(
                            +(FITBookingDetail?.TotalSightSeen || 0) +
                              +(FITBookingDetail?.SightSeenMarkup || 0),
                          )}
                        </span>
                      </div>
                      <div>
                        <span className="info-label">Conversion Rate :</span>{" "}
                        <span className="highlight">
                          {formatIndianNumber(
                            FITBookingDetail?.SightSeenConversionRate || 0,
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>SightSeen Name</th>
                        {/* <th>Total Amount</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {FITBookingDetail?.SightSeen.map((sightseen, index) => (
                        <tr key={index}>
                          <td>{sightseen.SightSeenName}</td>
                          {/* <td>{formatIndianNumber(misc.TotalAmount || 0)}</td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}

            {/* Total Summary Section */}

            {!withoutBifurcation ? (
              <div className="right-section">
                <div className="section-title summary-title">Total Summary</div>
                <table className="totals-table">
                  <tbody>
                    <tr>
                      <td className="label">Total Accommodation (A)</td>
                      <td className="value">
                        {formatIndianNumber(convertedTotalAccommodationRate)}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Total Transport (B)</td>
                      <td className="value">
                        {formatIndianNumber(convertedTotalTransportation)}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Total Miscellaneous (C)</td>
                      <td className="value">
                        {formatIndianNumber(convertedTotalMiscellaneous)}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Total SightSeen (D)</td>
                      <td className="value">
                        {formatIndianNumber(convertedTotalSightSeen)}
                      </td>
                    </tr>
                    <tr className="total-row">
                      <td className="label">Total (E) = (A + B + C + D)</td>
                      <td className="value">
                        {formatIndianNumber(calculateSubtotal())}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Discount (F)</td>
                      <td className="value">
                        {formatIndianNumber(FITBookingDetail?.DiscountAmt || 0)}
                      </td>
                    </tr>
                    <tr className="total-row">
                      <td className="label">Total (G) = (E - F)</td>
                      <td className="value">
                        {formatIndianNumber(calculateAfterDiscount())}
                      </td>
                    </tr>

                    <tr>
                      <td className="label">
                        GST Amount (H){" "}
                        {FITBookingDetail?.GSTPer
                          ? `(${FITBookingDetail?.GSTPer} %)`
                          : ""}
                      </td>
                      <td className="value">
                        {formatIndianNumber(FITBookingDetail?.GSTAmt || 0)}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">TCS (I)</td>
                      <td className="value">
                        {formatIndianNumber(FITBookingDetail?.TCSAmt || 0)}
                      </td>
                    </tr>
                    <tr
                      className="total-row grand-total"
                      style={{ backgroundColor: "#e8f4ff" }}
                    >
                      <td className="label bg-transparent">
                        Grand Total (J) = (G + H + I)
                      </td>
                      <td className="value bg-transparent">
                        {formatIndianNumber(FITBookingDetail?.GrandTotal || 0)}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Cancellation Amount (K)</td>
                      <td className="value">
                        {formatIndianNumber(
                          FITBookingDetail?.CancelledAmount || 0,
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">CreditNote Amount (L)</td>
                      <td className="value">
                        {formatIndianNumber(FITBookingDetail?.CNAmount || 0)}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Total Paid Amount (M)</td>
                      <td className="value">
                        {formatIndianNumber(
                          FITBookingDetail?.TotalPaidAmount || 0,
                        )}
                      </td>
                    </tr>
                    <tr
                      style={{ backgroundColor: "#efd5d5" }}
                      className="total-row grand-total"
                    >
                      <td className="label bg-transparent">
                        Remaining Amount (N) = (J + K - L - M)
                      </td>
                      <td className="value bg-transparent">
                        {formatIndianNumber(
                          (FITBookingDetail?.GrandTotal || 0) +
                            (FITBookingDetail?.CancelledAmount || 0) -
                            (FITBookingDetail?.TotalPaidAmount || 0),
                        )}
                      </td>
                    </tr>
                    {/* <tr
                className="total-row grand-total"
                style={{ backgroundColor: "#e8f4ff" }}
              >
                <td className="label bg-transparent">
                  Grand Total (K) = (F + G + H + I + J)
                </td>
                <td className="value bg-transparent">
                  {formatIndianNumber(FITBookingDetail?.GrandTotal || 0)}
                </td>
              </tr> */}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="right-section">
                <div className="section-title summary-title">Total Summary</div>
                <table className="totals-table">
                  <tbody>
                    <tr className="total-row">
                      <td className="label">Total (A)</td>
                      <td className="value">
                        {formatIndianNumber(calculateSubtotal())}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Discount (B)</td>
                      <td className="value">
                        {formatIndianNumber(FITBookingDetail?.DiscountAmt || 0)}
                      </td>
                    </tr>
                    <tr className="total-row">
                      <td className="label">Total (C) = (A - B)</td>
                      <td className="value">
                        {formatIndianNumber(calculateAfterDiscount())}
                      </td>
                    </tr>

                    <tr>
                      <td className="label">
                        GST Amount (D){" "}
                        {FITBookingDetail?.GSTPer
                          ? `(${FITBookingDetail?.GSTPer} %)`
                          : ""}
                      </td>
                      <td className="value">
                        {formatIndianNumber(FITBookingDetail?.GSTAmt || 0)}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">TCS (E)</td>
                      <td className="value">
                        {formatIndianNumber(FITBookingDetail?.TCSAmt || 0)}
                      </td>
                    </tr>
                    <tr
                      className="total-row grand-total"
                      style={{ backgroundColor: "#e8f4ff" }}
                    >
                      <td className="label bg-transparent">
                        Grand Total (F) = (C + D + E)
                      </td>
                      <td className="value bg-transparent">
                        {formatIndianNumber(FITBookingDetail?.GrandTotal || 0)}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Cancellation Amount (G)</td>
                      <td className="value">
                        {formatIndianNumber(
                          FITBookingDetail?.CancelledAmount || 0,
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">CreditNote Amount (H)</td>
                      <td className="value">
                        {formatIndianNumber(FITBookingDetail?.CNAmount || 0)}
                      </td>
                    </tr>
                    <tr>
                      <td className="label">Total Paid Amount (I)</td>
                      <td className="value">
                        {formatIndianNumber(
                          FITBookingDetail?.TotalPaidAmount || 0,
                        )}
                      </td>
                    </tr>
                    <tr
                      style={{ backgroundColor: "#efd5d5" }}
                      className="total-row grand-total"
                    >
                      <td className="label bg-transparent">
                        Remaining Amount (J) = (F + G - H - I)
                      </td>
                      <td className="value bg-transparent">
                        {formatIndianNumber(
                          (FITBookingDetail?.GrandTotal || 0) +
                            (FITBookingDetail?.CancelledAmount || 0) -
                            (FITBookingDetail?.TotalPaidAmount || 0),
                        )}
                      </td>
                    </tr>
                    {/* <tr
                className="total-row grand-total"
                style={{ backgroundColor: "#e8f4ff" }}
              >
                <td className="label bg-transparent">
                  Grand Total (K) = (F + G + H + I + J)
                </td>
                <td className="value bg-transparent">
                  {formatIndianNumber(FITBookingDetail?.GrandTotal || 0)}
                </td>
              </tr> */}
                  </tbody>
                </table>
              </div>
            )}
            {FITBookingDetail?.TourItinerary?.length > 0 && (
              <>
                <div className="itinerary-container">
                  <div className="section-title summary-title">
                    Daywise Itinerary
                  </div>
                  <table>
                    {FITBookingDetail?.TourItinerary.map((itinerary, index) => (
                      <tr key={itinerary.ItinaryID}>
                        <td className="day-column">
                          <div>DAY : {index + 1}</div>
                          <div className="Image-view-Field mt-2">
                            {itinerary?.ItineraryImage === "" ? (
                              <Link
                                to={itinerary?.ItineraryImage}
                                target="_Blanck"
                              >
                                <img
                                  className="k-form-field-wrap"
                                  src={itinerary?.ItineraryImage}
                                  alt="Itinerary Image"
                                />
                              </Link>
                            ) : (
                              <img
                                className="k-form-field-wrap"
                                src={defaultitineraryimage}
                                alt="Itinerary Image"
                              />
                            )}
                          </div>
                        </td>
                        <td className="activity-column">
                          <div className="activity-title">
                            {itinerary?.ItineraryTitle}
                          </div>
                          <div
                            className="activity-description"
                            dangerouslySetInnerHTML={{
                              __html: itinerary?.Description || "",
                            }}
                          />
                        </td>
                        <td className="location-column">
                          {itinerary?.Place}
                          <br />
                          <span className="meal-info">
                            ({itinerary?.FacilityName})
                          </span>
                        </td>
                      </tr>
                    ))}
                  </table>
                </div>
              </>
            )}

            {FITBookingDetail?.TermsNCondition && (
              <>
                <div className="section-title">Terms & Conditions</div>
                <div
                  className="section"
                  dangerouslySetInnerHTML={{
                    __html: FITBookingDetail?.TermsNCondition || "",
                  }}
                />
              </>
            )}

            {/* <div className="d-flex flex-column align-items-end mt-4">
          <strong>Thank you, </strong>
          <strong>{localStorage.getItem("FullName") || ""}</strong>
        </div> */}
          </div>
        </>
      ) : (
        <NoDataFoundPage />
      )}
    </>
  );
};

export default FITBookingPrint;
